import getLocalString from "constants/Localization";
import { useCreateDailyFormWorkOrderMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormWorkOrder() {
  const [mutation, { loading, data, error }] = useCreateDailyFormWorkOrderMutation({
    refetchQueries: ["customGetDailyFormWorkOrders", "customGetVehicleDailyFormWorkOrders"],
  });

  const [createDailyFormWorkOrder, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormWorkOrder",
    },
    {
      successMessage: getLocalString("fleet.create-work-order-success"),
      failureMessage: getLocalString("fleet.create-work-order-failure"),
    }
  );

  return [createDailyFormWorkOrder, context] as const;
}
